import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InfoIcon from '../../assets/icons/InfoIcon';
import { COLORS } from '../../styles/variables';
import PriceLabel from '../PriceLabel';
import {
  PriceBlockContainer,
  PriceCopy,
  PriceContainer,
  VehiclePrice,
  InfoIconWrapper,
} from './StickyNavbar.styles';
import { CarPricesType } from '../../types/oneGraphTypes';
import { formatPrice } from '../../utils/currencyTools';

interface PriceBolcComponentProps {
  onModalOpen: () => void;
  market: string;
  carPrices: CarPricesType[];
  isAvailableNow: boolean;
  cartypeText: string;
}

const PriceBlock: React.FC<PriceBolcComponentProps> = ({
  onModalOpen,
  market,
  carPrices,
  isAvailableNow,
  cartypeText,
}) => {
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage ?? 'en';
  const isFrench = language === 'fr';
  const isMarketUSA = market.includes('us');
  const modelPrice = carPrices?.find((item) => item.type === 'list')?.price?.value;
  const modelPriceRetail = carPrices?.find((item) => item.type === 'sale')?.price?.value;
  const textOverride = t('vehiclePricingBar.textOverrideDefault');

  const correctPrice = useMemo(() => {
    if (isMarketUSA && !isAvailableNow && cartypeText === 'N') return textOverride;
    if (isMarketUSA) return modelPrice ? formatPrice(modelPrice, isFrench) : textOverride;
    return modelPriceRetail ? formatPrice(modelPriceRetail, isFrench) : textOverride;
  }, [
    isMarketUSA,
    isAvailableNow,
    cartypeText,
    modelPrice,
    isFrench,
    textOverride,
    modelPriceRetail,
  ]);

  return (
    <>
      <PriceBlockContainer>
        <>
          <PriceCopy>
            <PriceLabel isAvailableNow={isAvailableNow} market={market} />
          </PriceCopy>
          <PriceContainer>
            <VehiclePrice data-testid="model-price">{correctPrice}</VehiclePrice>
            <InfoIconWrapper
              onClick={onModalOpen}
              aria-label={t('vehiclePricingBar.ariaLabel.legalInformation')}
              data-testid="price-legal-popover-trigger"
            >
              <InfoIcon color={COLORS.grey10} size={22} />
            </InfoIconWrapper>
          </PriceContainer>
        </>
      </PriceBlockContainer>
    </>
  );
};

export default PriceBlock;
